/**
 * @flow
 * @relayHash 0754a3df49112016fc1dc6a92e6d7cbc
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CartBadge_viewer$ref = any;
export type CartBadgeRefetchQueryVariables = {||};
export type CartBadgeRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CartBadge_viewer$ref
  |}
|};
export type CartBadgeRefetchQuery = {|
  variables: CartBadgeRefetchQueryVariables,
  response: CartBadgeRefetchQueryResponse,
|};
*/


/*
query CartBadgeRefetchQuery {
  viewer {
    ...CartBadge_viewer
    id
  }
}

fragment CartBadge_viewer on Viewer {
  id
  cartBadge {
    approvalFlag
    totalPurchaseNumber
  }
}
*/

const node/*: ConcreteRequest*/ = {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CartBadgeRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CartBadge_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CartBadgeRefetchQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cartBadge",
            "storageKey": null,
            "args": null,
            "concreteType": "CartBadge",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "approvalFlag",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalPurchaseNumber",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CartBadgeRefetchQuery",
    "id": null,
    "text": "query CartBadgeRefetchQuery {\n  viewer {\n    ...CartBadge_viewer\n    id\n  }\n}\n\nfragment CartBadge_viewer on Viewer {\n  id\n  cartBadge {\n    approvalFlag\n    totalPurchaseNumber\n  }\n}\n",
    "metadata": {}
  }
};
// prettier-ignore
(node/*: any*/).hash = '319aa645245e53c363c52863ccdaf213';
module.exports = node;
